import { MeetingDetails } from '../../../services/api.service';

const VIDEO_EXT = /\.(mp4|webm|mov|mkv|avi|m4v)$/i;

/** Есть ли у встречи видеофайл (основной или прикреплённый Teams/Zoom). */
export function meetingHasVideoFile(details: Pick<MeetingDetails, 'has_video_file' | 'pipeline' | 'file_path'>): boolean {
  if (details.has_video_file === true) return true;
  if (details.pipeline === 'video') return true;
  return VIDEO_EXT.test(details.file_path || '');
}
